import React from 'react';

type StoreButtonProps = {
  url: string;
  height?: number;
};

const buttonStyle = (height: number): React.CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  height,
  minWidth: 180,
  padding: '8px 14px',
  border: '2px solid #202020',
  borderRadius: 10,
  backgroundColor: '#fff',
  color: '#202020',
  textDecoration: 'none',
  boxSizing: 'border-box',
  fontFamily:
    'Outfit, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  lineHeight: 1.1,
});

const titleStyle: React.CSSProperties = {
  fontSize: 11,
  display: 'block',
};

const storeNameStyle: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 700,
  display: 'block',
};

const GooglePlayIcon: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 36 36'
    fill='none'
    aria-hidden
  >
    <path
      fill='#2299F8'
      d='M19.728 17.3 3.496 33.576c-.776-.736-1.195-1.745-1.195-2.839V5.21c0-1.115.44-2.124 1.237-2.88l16.19 14.97Z'
    />
    <path
      fill='#FFC107'
      d='M33.757 17.973c0 1.473-.797 2.776-2.118 3.512l-4.613 2.566-5.726-5.3-1.572-1.45 6.06-6.078 5.85 3.239c1.322.736 2.12 2.04 2.12 3.511Z'
    />
    <path
      fill='#5ACF5F'
      d='M19.728 17.3 3.538 2.33c.21-.211.483-.4.755-.569 1.321-.799 2.915-.82 4.278-.063l17.217 9.525-6.06 6.077Z'
    />
    <path
      fill='#F84437'
      d='M27.026 24.05 8.57 34.25a4.166 4.166 0 0 1-2.097.546c-.755 0-1.51-.189-2.18-.609a3.807 3.807 0 0 1-.798-.61L19.728 17.3l1.572 1.451 5.726 5.3Z'
    />
  </svg>
);

const AppleIcon: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 36 36'
    fill='none'
    aria-hidden
  >
    <path
      fill='#000'
      d='M22.667 6.639C23.76 5.223 24.59 3.22 24.29 1.178c-1.789.124-3.88 1.272-5.098 2.767-1.111 1.356-2.026 3.37-1.67 5.328 1.955.061 3.975-1.114 5.145-2.634Z'
    />
    <path
      fill='#000'
      d='M31.36 12.466c-1.718-2.16-4.132-3.414-6.412-3.414-3.009 0-4.282 1.445-6.373 1.445-2.155 0-3.793-1.44-6.396-1.44-2.556 0-5.278 1.566-7.004 4.245-2.426 3.773-2.011 10.865 1.921 16.906 1.407 2.162 3.286 4.593 5.744 4.614 2.187.02 2.803-1.407 5.767-1.422 2.963-.016 3.525 1.441 5.708 1.418 2.46-.02 4.442-2.713 5.849-4.875 1.009-1.55 1.384-2.33 2.166-4.079-5.69-2.172-6.601-10.285-.97-13.399Z'
    />
  </svg>
);

export const GooglePlayStoreButton: React.FC<StoreButtonProps> = ({
  url,
  height = 54,
}) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    style={buttonStyle(height)}
    aria-label='Disponível no Google Play'
  >
    <GooglePlayIcon />
    <span>
      <span style={titleStyle}>GET IT ON</span>
      <span style={storeNameStyle}>Google Play</span>
    </span>
  </a>
);

export const AppStoreStoreButton: React.FC<StoreButtonProps> = ({
  url,
  height = 54,
}) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    style={buttonStyle(height)}
    aria-label='Baixar na App Store'
  >
    <AppleIcon />
    <span>
      <span style={titleStyle}>Download on the</span>
      <span style={storeNameStyle}>App Store</span>
    </span>
  </a>
);
